<template>
    <div v-if="$store.state.user">
        <div class="logoutbutton d-inline-block z-clickable red--text text-center" v-ripple @click="$store.dispatch('logout')">
            <div><v-icon color="red">mdi-logout</v-icon></div>
            <div>{{$translate('Log out')}}</div>
        </div>
    </div>
    <div v-else></div>
</template>

<script>
export default {
    name: 'zoezi-logout',

    zoezi: {
        title: 'Log out',
        icon: 'mdi-logout'
    }
}
</script>
